module.exports = __webpack_public_path__ + "static/sm-sendgrid-alternatives-og-fa3dd215fd284ffa6971887178fbed03.jpg";